import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTankCoveredBoot = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 85,
	viewBox: "0 0 100.0 85.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 5.0 5.0 L 5.0 75.0 L 60.0 75.0 L 70.0 85.0 L 95.0 85.0 L 95.0 5.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 10.0 L 0.0 0.0 L 100.0 0.0 L 100.0 10.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgTankCoveredBoot;
